import { render, staticRenderFns } from "./NewIncome.vue?vue&type=template&id=0cfd41ec&"
import script from "./NewIncome.vue?vue&type=script&lang=js&"
export * from "./NewIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports